"use client";

import Script from "next/script";

export default function JsonLdLocalBusiness() {
	const jsonLd = {
		"@context": "https://schema.org",
		"@type": "LocalBusiness",
		name: "Los Amos del Calabozo",
		url: "https://www.losamosdelcalabozo.com",
		logo: "https://www.losamosdelcalabozo.com/images/logo.png",
		description:
			"Organizamos eventos de rol en Madrid con directores de juego profesionales: cumpleaños, despedidas, team building y más.",
		address: {
			"@type": "PostalAddress",
			addressLocality: "Madrid",
			addressCountry: "ES",
		},
		areaServed: "Madrid",
		telephone: "+34 34 642 36 79 72",
	};

	return (
		<Script
			id="jsonld-localbusiness"
			type="application/ld+json"
			strategy="afterInteractive"
			dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }}
		/>
	);
}
